import { motion } from "framer-motion";
import { Petal } from "./Motifs";

// Sparse, slow-drifting petals in restrained blush & gold — elegance over play.
const PETALS = [
  { left: "12%", size: 15, delay: 0, dur: 26, color: "#E8B4B8", drift: 26 },
  { left: "31%", size: 11, delay: 6, dur: 30, color: "#C5A059", drift: -22 },
  { left: "58%", size: 13, delay: 3, dur: 28, color: "#E8B4B8", drift: 20 },
  { left: "74%", size: 10, delay: 9, dur: 32, color: "#C5A059", drift: -18 },
  { left: "88%", size: 14, delay: 4.5, dur: 27, color: "#E8B4B8", drift: 24 },
];

export default function Petals() {
  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      aria-hidden="true"
    >
      {PETALS.map((p, i) => (
        <motion.div
          key={i}
          className="absolute -top-16"
          style={{ left: p.left, width: p.size, height: p.size }}
          initial={{ y: -80, opacity: 0, rotate: 0 }}
          animate={{
            y: ["-8vh", "112vh"],
            x: [0, p.drift, 0],
            rotate: [0, 160, 320],
            opacity: [0, 0.5, 0.5, 0],
          }}
          transition={{
            duration: p.dur,
            delay: p.delay,
            repeat: Infinity,
            ease: "linear",
          }}
        >
          <Petal className="w-full h-full" color={p.color} />
        </motion.div>
      ))}
    </div>
  );
}
